export const FETCH_DATA_REQUEST = '@monitor/FETCH_DATA_REQUEST';
export const FETCH_DATA_FAILURE = '@monitor/FETCH_DATA_FAILURE';
export const FETCH_DATA_SUCCESS = '@monitor/FETCH_DATA_SUCCESS';
export const RELOAD_DATA = '@monitor/RELOAD_DATA';
